export default __webpack_public_path__ + "static/media/keyboard_arrow_right.cf323c9f.svg";